import { Pipe, PipeTransform } from '@angular/core';
import { ImageHelperService } from '../../services/catalog/image-helper.service';
import { Article } from '@lobos/library';
import { CloudinaryImage } from '@cloudinary/url-gen';

@Pipe({
  name: 'articleMainImage',
})
export class ArticleMainImagePipe implements PipeTransform {
  constructor(private imageHelperService: ImageHelperService) {}

  transform(article: Article): CloudinaryImage {
    return this.imageHelperService.getArticleMainImage(article)!;
  }
}
